import { useState } from "react";

import { Main } from "./styled";
import {
  MyAccount,
  SubscriptionsOfServiceType,
  SubscriptionModal,
} from "./components";
import { serviceTypes } from "./__serviceTypes__";
import { getSubscriptionsList } from "../../services";
import { useFetch } from "../../hooks";
import { LoadingAnimation } from "../LoadingAnimation";

export const SubscriptionsPage = () => {
  const [subscriptions] = useFetch(getSubscriptionsList);
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  return (
    <>
      <Main>
        {subscriptions ? (
          serviceTypes.map((item) => (
            <SubscriptionsOfServiceType
              key={item.id}
              serviceType={item}
              selectedSubscription={setSelectedSubscription}
              subscriptions={subscriptions.filter(
                (sub) => sub.serviceType === item.id
              )}
            />
          ))
        ) : (
          <LoadingAnimation className="loading" />
        )}
      </Main>
      {selectedSubscription && (
        <SubscriptionModal
          subscription={selectedSubscription}
          closeModal={() => {
            setSelectedSubscription(null);
          }}
        />
      )}
    </>
  );
};
